import { connect } from "react-redux";
import TopLines from "./TopLines";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TopLines);
